import NewClaimIcon from 'assets/images/home/new-claim.svg';
import { StyledTitle } from 'components/StyledTitle';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const TitleWrapper = styled.div`
  grid-column: 1/3;
  display: flex;
  gap: 10px;
  align-items: center;
`;

interface ClaimDetailTitleProps {
  title?: string;
}

export const ClaimDetailTitle = ({ title = 'newClaim.title' }: ClaimDetailTitleProps) => {
  const { t } = useTranslation();
  return (
    <TitleWrapper>
      <img src={NewClaimIcon} alt="new claim" />
      <StyledTitle level={4}>{t(title)}</StyledTitle>
    </TitleWrapper>
  );
};
